import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Data } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { IDENTITY_API_URL_TOKEN } from '@identity/identity-url-token';

@Injectable({
    providedIn: 'root'
})
export class TranslationLoaderService {
    constructor(
        private translate: TranslateService,
        private http: HttpClient,
        @Inject(IDENTITY_API_URL_TOKEN) private identityUrl: string
    ) {}

    async loadTranslations(routeData?: Data) {
        const moduleName = routeData !== undefined && routeData !== null ? routeData['moduleName'] : '';
        if (moduleName !== undefined && moduleName !== '') {
            const lang = this.translate.currentLang || 'en';
            const translationUrl = `${this.identityUrl}/api/translation/${moduleName}?lang=${lang}`;
            this.translate.use(lang).subscribe(() => {
                this.http.get(translationUrl).subscribe(translations => {
                    this.translate.setTranslation(lang, translations, true);
                });
            });
        }
    }
}
